import React, { useEffect } from 'react'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Tab, Tabs } from '@mui/material'
import { Item } from '../../../common/snippets'
import { styled } from '@mui/system'
import { useState } from 'react'
import FranchiseeToOwn from './franchiseeToOwn/FranchiseeToOwn'
import FranchiseeBookings from './franchiseeBookings/FranchiseeBookings'
import OwnBookings from './ownBooking/OwnBookings'
import { connect } from 'react-redux'
import { isEmpty } from '../../../common/helper'
import { updateOwnBooingFitlerData } from '../../../../store/reports/reports_action'
import OwnBookingsNew from './ownBooking/OwnBookingsNew'
import FranchiseeBookingsNew from './franchiseeBookings/FranchiseeBookingsNew'
import FranchiseeToOwnNew from './franchiseeToOwn/FranchiseeToOwnNew'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { useAtom, useSetAtom } from 'jotai'
import { CargoRoleRightsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { PostRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    height: 4,
    backgroundColor: theme.palette.primary.main,
  },
}))
const tabSx = {
  minHeight: '30px',
  height: '35px',
  flex: 1,
  maxWidth: '150px',
  padding: '5px 12px',
  position: 'relative',

  '&.Mui-selected::after': {
    content: '""',
    position: 'absolute',

    left: '6px',    
    right: '6px',    

    bottom: '0px',
    height: '4px',
    backgroundColor: '#0086ff',
  },
}
const Index = (props) => {
  const {
    data: { common, reports },
    updateOwnBooingFitlerData,
  } = props
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const RoleRightTable1 = cargoRoleRights?.Table1 || []
  const roleRightsData = RoleRightTable1?.[0] || {}
  let { AllowViewAllBranchReport, AllowBranchInchargeRights, AllowViewAllBranchOfCityReport, AllowGroupofCompanies, AllowExportExcel } = { ...roleRightsData }
  const setLoader = useSetAtom(globalLoaderAtom)
  const [selectedTab, setSelectedTab] = useState(0)
  const [disableBtn, setDisableBtn] = useState(false)
  const [companySettingsData, setCompanySettingsData] = useState([])
  const [searchParams] = useSearchParams()
  const reportName = 'Booking'
  const tabLabels = ['Own Bookings', 'Franchisee Bookings', 'Franchisee to own']
  const tabLabelsForMaven = ['Own', 'Franchisee', 'Fr. to own']
  let { loginData = {} } = useToken()
      let isFromUrl = false
      if (!loginData) {
          loginData = {}
          loginData.BusCrsCheckSum = Number(searchParams.get('CHK') || 0)
          loginData.intCompanyID = Number(searchParams.get('C') || 0)
          loginData.intBranchCityID = Number(searchParams.get('CT') || 0)
          loginData.strCityName = searchParams.get('CTN') || 0
          loginData.intUserID = Number(searchParams.get('U') || 0)
          loginData.strCompanyName = searchParams.get('CN') || ''
          loginData.intBranchID = Number(searchParams.get('B') || 0)
          loginData.strCompanyName = searchParams.get('CN') || ''
          loginData.strUserName = searchParams.get('UN') || ''
          loginData.strBranchName = searchParams.get('BN') || ''
          loginData.IsBranchAdmin = Number(searchParams.get('IBA') || 0)
          loginData.IsMTPLAdmin = Number(searchParams.get('IMPTLA') || 0)
          loginData.IsAdmin = Number(searchParams.get('IA') || 0)
          AllowViewAllBranchOfCityReport = Number(searchParams.get('AllowViewAllBranchOfCityReport') || 0)
          AllowViewAllBranchReport = Number(searchParams.get('AllowViewAllBranchReport') || 0)
          AllowBranchInchargeRights = Number(searchParams.get('AllowBranchInchargeRights') || 0)
          AllowGroupofCompanies = Number(searchParams.get('AllowGroupofCompanies') || 0)
          AllowExportExcel = Number(searchParams.get('AllowExportExcel') || 0)
          isFromUrl = true
      }
  let effectiveLoginData = !isEmpty(loginData) ? loginData : common?.loginData || {}
  let effectiveRoleRights =
    !isEmpty(roleRightsData)
      ? roleRightsData
      : !isEmpty(common?.roleRights?.Table1?.[0])
        ? common?.roleRights?.Table1?.[0]
        : {
            AllowViewAllBranchOfCityReport: Number(searchParams.get('AllowViewAllBranchOfCityReport') || 0),
            AllowViewAllBranchReport: Number(searchParams.get('AllowViewAllBranchReport') || 0),
            AllowBranchInchargeRights: Number(searchParams.get('AllowBranchInchargeRights') || 0),
            AllowGroupofCompanies : Number(searchParams.get('AllowGroupofCompanies') || 0),
            AllowExportExcel : Number(searchParams.get('AllowExportExcel') || 0),
          }
          const { intCompanyID, intUserID, strCompanyName } = effectiveLoginData
          const handleTabChange = (event, newValue) => {
            setSelectedTab(newValue)
            updateOwnBooingFitlerData([])
          }
          useEffect(() => {
            if ((isFromUrl && intUserID) || (!isEmpty(roleRightsData) && !isEmpty(effectiveLoginData))) {
              setDisableBtn(
                !(
         AllowViewAllBranchReport ||
         AllowBranchInchargeRights ||
         AllowViewAllBranchOfCityReport ||
          effectiveLoginData?.IsBranchAdmin ||
          effectiveLoginData?.IsMTPLAdmin ||
          effectiveLoginData?.IsAdmin
        )
      )
    }
  }, [roleRightsData, effectiveLoginData, isFromUrl, intUserID])
  useEffect(() => {
    if (intCompanyID) {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intUserID: loginData?.intUserID,
      }
      setLoader(true)
      PostRequest(urls.getCargoSetting, obj)
        .then((res) => {
          setLoader(false)
          if (res.status === 'Success') {
            setCompanySettingsData(res.Data)
          } else {
            setCompanySettingsData([])
          }
        })
        .catch((error) => {
          setLoader(false)
          setCompanySettingsData([])
        })
    }
  }, [ intCompanyID])
  return (
    <Item sx={{ padding: '0' }} className="reports">
      {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.1; }`}</style>}
      <Box className="reports">
        {isFromUrl ? <></> : <ReportHeading reportName={reportName} />}
      </Box>
      <Box>
        <StyledTabs
          aria-label="basic tabs example"
          value={selectedTab}
          onChange={handleTabChange}
          sx={{
            backgroundColor: '#e5f3fe',
            height: '30px',
            minHeight: '37px',
            border: 'none',
            padding: '0px 25px',

            ...(isFromUrl && {
              '& .MuiTabs-indicator': {
                display: 'none',
              },
            }),
          }}
        >
          <Tab
            sx={isFromUrl ? tabSx : undefined}
            label={isFromUrl ? tabLabelsForMaven[0] : tabLabels[0]}
          />

          <Tab
            disabled={disableBtn}
            sx={isFromUrl ? tabSx : undefined}
            label={isFromUrl ? tabLabelsForMaven[1] : tabLabels[1]}
          />

          <Tab
            sx={isFromUrl ? tabSx : undefined}
            label={isFromUrl ? tabLabelsForMaven[2] : tabLabels[2]}
          />
        </StyledTabs>
      </Box>
      <Box>
        {(selectedTab === 0 && <OwnBookingsNew isFromUrl={isFromUrl} loginData={effectiveLoginData} roleRightsData={effectiveRoleRights} companySettingsData={companySettingsData} />) ||
          (selectedTab === 1 && <FranchiseeBookingsNew isFromUrl={isFromUrl} loginData={effectiveLoginData} roleRightsData={effectiveRoleRights} companySettingsData={companySettingsData} />) ||
          (selectedTab === 2 && <FranchiseeToOwnNew isFromUrl={isFromUrl} loginData={effectiveLoginData} roleRightsData={effectiveRoleRights} companySettingsData={companySettingsData} />)}
      </Box>
    </Item>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateOwnBooingFitlerData }
export default connect(mapStateToProps, mapDispatchToProps)(Index)
